"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var listActions = require("@caddigital/sok-reducers/lib/actions/customer/list");
var search_1 = require("utils/search");
var Types = require("types");
var constants_1 = require("utils/constants");
var getFilters = function () { return [
    {
        filterBy: 'only-my-clients',
        label: (0, translation_1.getLocalization)('admin/customerManagement/filters/onlyMyCustomers')
    },
    {
        filterBy: 'only-sokopro-clients',
        label: (0, translation_1.getLocalization)('admin/customerManagement/filters/onlySokoproCustomers')
    },
    {
        filterBy: 'all-clients',
        label: (0, translation_1.getLocalization)('admin/customerManagement/filters/allCompanies')
    }
]; };
var mapStateToProps = function (state) {
    return {
        filters: getFilters(),
        list: state.customer.list
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    setFilterBy: function (filterBy) { return function () { return (dispatch(listActions.setFilterBy(filterBy)),
        dispatch(listActions.fetchCustomerListRequest('ADMIN', {
            includeEmployees: true,
            includeFederation: false,
            filterBy: filterBy
        }))); }; }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), recompose_1.pure);
var searchTimer;
var clearSearchCross = function (props) {
    return (React.createElement("span", { className: 'search-box-right' }, props.queryParams.search !== undefined &&
        props.queryParams.search !== '' && (React.createElement(Icon_1.Icon, { onClick: function () {
            if (searchTimer) {
                clearTimeout(searchTimer);
            }
            props.update((0, search_1.getQueryParams)(__assign(__assign({}, props.queryParams), { search: undefined })));
            props.setSearchString(null);
        }, className: 'fa-times' }))));
};
var SearchArea = (0, recompose_1.compose)((0, recompose_1.withState)('searchString', 'setSearchString', null), recompose_1.pure)(function (props) { return (React.createElement(sok_ui_1.TextInput, { placeholder: (0, translation_1.getLocalization)('portal/bidView/search'), onBlur: function () {
        if (searchTimer) {
            clearTimeout(searchTimer);
        }
        if (props.searchString !== null) {
            props.update((0, search_1.getQueryParams)(__assign(__assign({}, props.queryParams), { search: props.searchString })));
            props.setSearchString(null);
        }
    }, value: (props.searchString !== null
        ? props.searchString
        : props.queryParams.search) || '', onKeyDown: function (event) {
        if (event.key === 'Enter') {
            if (searchTimer) {
                clearTimeout(searchTimer);
            }
            if (props.searchString !== null) {
                props.update((0, search_1.getQueryParams)(__assign(__assign({}, props.queryParams), { search: props.searchString })));
                props.setSearchString(null);
            }
        }
    }, onChange: function (e) {
        var value = e.target.value;
        props.setSearchString(value);
        if (searchTimer) {
            clearTimeout(searchTimer);
        }
        searchTimer = setTimeout(function () {
            props.update((0, search_1.getQueryParams)(__assign(__assign({}, props.queryParams), { search: value })));
        }, constants_1.SEARCH_TIMEOUT);
    }, icon: React.createElement(Icon_1.Icon, { key: 'icon', className: 'fa-search' }), iconRight: clearSearchCross(props) })); });
exports.default = enhance(function (props) {
    var filterBy = props.filters.find(function (x) { return x.filterBy === props.list.filterBy; });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'search-area' },
            React.createElement(SearchArea, { queryParams: props.queryParams, update: props.history.push })),
        React.createElement("div", { className: 'customer-management-view-filters', key: 'filters' },
            React.createElement(sok_ui_1.Dropdown2, { className: 'filter-list-dropdown' },
                React.createElement(sok_ui_1.Button, { className: 'full-width text-left', text: (filterBy || props.filters[0]).label, border: 'yellow', size: 'large', color: 'dark-gray', icon: React.createElement(Icon_1.Icon, { key: "icon", className: "fa-filter" }), iconRight: React.createElement(Icon_1.Icon, { key: "right-icon", className: "fa-chevron-down" }) }),
                React.createElement(sok_ui_1.Dropdown2Menu, { className: 'hovered filter-list' },
                    React.createElement(sok_ui_1.Dropdown2MenuItem, { disabled: true }, (0, translation_1.getLocalization)('admin/customerManagement/dropdown/filterBy')),
                    props.filters.map(function (val, key) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: key, className: 'order-list-dropdown-item ', onClick: props.setFilterBy(val.filterBy) }, val.label)); }))))));
});
